import React, { useEffect, useCallback } from 'react';
import { Flex, Heading, Button, Text } from 'rebass';
import Recaptcha from 'react-recaptcha';
import Field from 'components/Field';
import ErrorMessage from 'components/ErrorMessage';
import colors from 'theme/colors';
import { RECRUITER, EMPLOYER } from 'constants/index';
import { Link } from 'react-router-dom';

const UserCompanyInfoStep: React.FC<any> = (props: any): JSX.Element => {
  const { userRole, signUpInitialStepHandler, submitting, submitError, submitErrors, form } = props;

  useEffect(() => {
    return () => {
      signUpInitialStepHandler();
    };
  }, [signUpInitialStepHandler]);

  const verifyRecaptchaHandler = useCallback(
    (response: string) => {
      form.change('recaptchaToken', response);
    },
    [form]
  );
  return (
    <Flex flexDirection="column" alignItems="center" py={7} px={4}>
      <Heading fontSize={['36px']} textAlign="center" fontWeight={5} mb={4}>
        Tell us about your company to complete the registration
      </Heading>
      {submitError && <ErrorMessage>{submitError}</ErrorMessage>}
      <Flex width="100%" flexDirection="column" alignItems="center" css="max-width: 400px">
        <Field name="companyName" label="Company Name" required labelAsterisk />
        <Field name="contactPerson" label="Contact Person" required labelAsterisk />
        <Field name="contactPersonTitle" label="Contact Person Title" required labelAsterisk />
        <Field name="phoneNumber" label="Phone Number" required labelAsterisk />
        {userRole === EMPLOYER && (
          <Field name="companyBio" label="Company Bio" inputType="textarea" />
        )}
        {userRole === RECRUITER && (
          <Field name="recruitingLicence" label="Recruiting Licence" required labelAsterisk />
        )}
        <Field
          name="country"
          label="Country"
          inputType="select"
          selectOptions={['USA', 'Canada']}
          required
          labelAsterisk
        />
        <Field name="city" label="City" required labelAsterisk />
        <Field name="address" label="Address" required labelAsterisk />
        <Flex width="100%" justifyContent="space-between">
          <Field
            name="province"
            label="Province-State"
            width="175px"
            placeholder="BC"
            pattern="[A-Z]{2}"
            patternMismatch="Needs to be 2 capital letters"
            required
            labelAsterisk
          />
          <Field name="postalCode" label="Postal Code" width="175px" required labelAsterisk />
        </Flex>
        <Flex alignItems="center" mb={2}>
          <Field name="privacyPolicy" inputType="checkbox" width="20px" required />
          <Text fontWeight={500} ml={1} css="max-width: 345px;">
            Yes, I understand and agree to the&nbsp;
            <Link
              to="/terms"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: colors.turquoise, textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Terms of Service
            </Link>
            &nbsp;and&nbsp;
            <Link
              to="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: colors.turquoise, textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Privacy Policy
            </Link>
            .
          </Text>
        </Flex>
        <Flex mb={2}>
          <Recaptcha
            sitekey="6LcFT8wsAAAAANJr9ZGEuKw-vJ3n-_wjfbHpYzkf"
            render="explicit"
            verifyCallback={verifyRecaptchaHandler}
          />
        </Flex>
        {submitErrors && <ErrorMessage>{submitErrors.recaptchaToken}</ErrorMessage>}
        <Button
          type="submit"
          variant={submitting ? 'disabled' : 'primary'}
          mt={2}
          disabled={submitting}
        >
          Create an Account
        </Button>
      </Flex>
    </Flex>
  );
};

export default UserCompanyInfoStep;
